import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ResumeCheckoutService {
    attendanceId: null;

    setNewAttendanceId(attendanceId) {
        localStorage.setItem('new_attendance_id', attendanceId);
    }

    getNewAttendanceId() {
        let new_attendance_id;

        try {
            new_attendance_id = localStorage.getItem('new_attendance_id');
        } catch (error) {}

        return new_attendance_id;
    }

    setNewAttendanceToken(token) {
        localStorage.setItem('new_attendance_token', token);
    }

    getNewAttendanceToken() {
        let new_attendance_token;

        try {
            new_attendance_token = localStorage.getItem('new_attendance_token');
        } catch (error) {}

        return new_attendance_token;
    }
}
